/**
 * normalize.js — Shared text normalization & escape utilities
 */

/** Strip accents and lowercase */
export const normalize = (s) =>
	(s || "")
		.toString()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.toLowerCase();

/** Build a normalized string + original-index map (accent-safe highlight) */
export function normalizeWithMap(str) {
	let norm = "";
	const map = [];
	for (let i = 0; i < str.length; i++) {
		const base = str[i].normalize("NFD").replace(/[\u0300-\u036f]/g, "");
		for (let k = 0; k < base.length; k++) {
			norm += base[k].toLowerCase();
			map.push(i);
		}
	}
	return { norm, map };
}

/** Escape special regex characters */
export const escapeRegExp = (s) =>
	s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/** Escape HTML entities */
export const escapeHtml = (str) =>
	(str || "").replace(
		/[&<>"']/g,
		(c) =>
			({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[
				c
			])
	);

/** Parse a query string respecting "quoted phrases" */
export function parseQuery(q) {
	const out = [];
	const rx = /"([^"]+)"|(\S+)/g;
	let m;
	while ((m = rx.exec(q)) !== null) out.push(m[1] || m[2]);
	return out;
}
